import React, { useState } from 'react'
import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  MenuItem
} from '@mui/material'
import { useTranslation } from 'react-i18next'

import { archive } from 'store/actions/pipeline'

const LS_ARCHIVE = 'dontShowCheckedArchive'

const ArchiveDialog = ({ handleSubmit, handleClose }) => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)

  const [skipNextTime, setSkipNextTime] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  return (
    <Dialog className="Profile-gift-analysis-dialog" open={true} onClose={handleClose}>
      <DialogTitle>{t.cards.archiveTitle}</DialogTitle>
      <DialogContent>
        <p>{t.cards.archiveConfirm}</p>
        <FormControlLabel
          control={
            <Checkbox checked={skipNextTime} onCheck={() => setSkipNextTime(!skipNextTime)} />
          }
          label={t.cards.noShow}
        />
      </DialogContent>
      <DialogActions>
        {!isLoading && (
          <Button onClick={handleClose} disabled={isLoading} variant="text">
            {t.global.cancel}
          </Button>
        )}
        <Button
          onClick={async () => {
            setIsLoading(true)
            await handleSubmit(skipNextTime)
            handleClose()
          }}
          disabled={isLoading}
        >
          {!isLoading ? t.cards.archive : <CircularProgress size={20} />}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const ArchiveCardAction = ({ opportunityId, setShowDialog, loadData, dispatch }) => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)

  const handleSubmit = async skipNextTime => {
    if (skipNextTime) localStorage.setItem(LS_ARCHIVE, true)

    await dispatch(archive(opportunityId))
    await dispatch(loadData())
  }

  const handleArchive = () => {
    const skip = localStorage[LS_ARCHIVE] === 'true'

    if (skip) {
      setShowDialog(false)
      return handleSubmit()
    }

    setShowDialog(
      <ArchiveDialog handleSubmit={handleSubmit} handleClose={() => setShowDialog(false)} />
    )
  }

  return (
    <MenuItem className="Material-cards__expanded-actions-item" onClick={handleArchive}>
      {t.cards.archive}
    </MenuItem>
  )
}

export default ArchiveCardAction
